import { NavLink, Link } from 'react-router-dom'

import styles from './NavBar.module.css'

const NavBar = (props) => {
    
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  
  return (
    <nav className={styles.navbar}>
        <h1><Link to="/" className={styles.link_start} onClick={() => {props.setOpen(false); scrollToTop()}}>Socialin</Link></h1>
        <nav className={styles.nav}>
            <ul className={styles.nav_links}>
                {/* <NavLink  onClick={() => props.setOpen(!props.open)}><span>{props.language === 'ca' ? 'Funcions' : props.language === 'es-ES' ? 'Funciones' : 'Functions'}</span>{props.open === false ? <i className="fa-solid fa-angle-down"></i> : <i className="fa-solid fa-angle-up"></i>}</NavLink>
                <NavLink to="/next"><span className={styles.nomovile}>{props.language === 'ca' ? 'Pròximament' : props.language === 'es-ES' ? 'Proximamente' : 'Comming Soon'}</span><span className={styles.movile}>⚙️</span></NavLink> */}
                <NavLink  onClick={() => props.setOpen(!props.open)}><span>Funcions</span>{props.open === false ? <i className="fa-solid fa-angle-down"></i> : <i className="fa-solid fa-angle-up"></i>}</NavLink>
                <NavLink to="/next"><span className={styles.nomovile}>Pròximament</span><span className={styles.movile}>⚙️</span></NavLink>
            </ul>
        </nav>
        <div className={styles.nav_session}>
          {/* <Link to="https://www.socialin.es/" className={styles.link_session} onClick={scrollToTop}><span>{props.language === 'ca' ? 'Iniciar sessió' : props.language === 'es-ES' ? 'Iniciar sessión' : 'Sign In'}</span><i className="fa-solid fa-chevron-right"></i></Link> */}
          <Link to="https://www.socialin.es/" className={styles.link_session} onClick={scrollToTop}><span>Iniciar sessió</span><i className="fa-solid fa-chevron-right"></i></Link>
        </div>
    </nav>
  )
}

export default NavBar